import Axios from "axios";
import qs from "qs";

const API_VERSION_HEADER_NAME = "X-Api-Version";
const API_VERSION_HEADER_VALUE = "latest";
const CSRF_PROTECTION_HEADER_NAME = "X-CSRF-Protected";

export const createAxios = (baseUrl: string) =>
  Axios.create({
    baseURL: baseUrl,
    headers: {
      "Content-Type": "application/vnd.api+json",
      [API_VERSION_HEADER_NAME]: [API_VERSION_HEADER_VALUE],
      [CSRF_PROTECTION_HEADER_NAME]: "",
    },
    withCredentials: true,
    paramsSerializer: (queryParams: Record<string, unknown>) =>
      qs.stringify(queryParams, {
        arrayFormat: "comma",
      }),
  });
